import React, { useCallback, useContext } from 'react';

import { HSTableContext } from '../../../Common/Table/HSTable/hs-table.context';
import { WorkEquipmentLayoutContext } from '../work-equipment-layout.context';
import WorkEquipmentLayoutEditForm from './EditForm';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData } = useContext(WorkEquipmentLayoutContext);
  const { refresh } = useContext(HSTableContext);

  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await refresh();
      }
      setEditDialogOpened(false);
    },
    [refresh, setEditDialogOpened]
  );

  return <WorkEquipmentLayoutEditForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
